require("./reviews.scss");

const setEditorialModal = () => {
    const elements = document.querySelectorAll('[data-role="hpl-editorial-modal"]');

    if (elements) {
        let isMobile = window.matchMedia("(max-width: 991px)").matches;
        let toggle = isMobile ? '' : 'lightbox';

        elements.forEach(el => {
            let hyperlink = isMobile ? el.getAttribute('data-url') : '#';

            el.setAttribute('data-toggle', toggle);
            el.setAttribute('href', hyperlink);
        });
    }
};

const setRatingsAnimation = () => {
    let editorial = document.querySelector('[data-role="editorial"]');
    let ratings = document.querySelectorAll('[data-role="editorial-rating"]');

    if (ratings) {
        ratings.forEach(rating => {
            let ratingInner = rating.querySelector('[data-role="editorial-rating-inner"]');
            let roundRadius = ratingInner.getAttribute('r');
            let roundPercent = ratingInner.getAttribute('data-percent');
            let roundCircum = 2 * roundRadius * Math.PI;
            let roundDraw = roundPercent * roundCircum / 100;
            let ratingText = rating.querySelector('[data-role="editorial-rating-text"]');
            let controllerEditorial = new ScrollMagic.Controller();
            new ScrollMagic.Scene({
                triggerElement: editorial, triggerHook: 0.5, duration: 200
            })
                .on('enter', () => {
                    ratingInner.style.setProperty('stroke-dasharray', roundDraw + ' 999');

                    for (let i = 1; i <= roundPercent; i++) {
                        setTimeout(() => { ratingText.innerHTML = i; }, i * 14);
                    }
                    controllerEditorial.destroy();
                })
                .addTo(controllerEditorial);
        });
    }
};

window.addEventListener("resize", () => {
    setEditorialModal();
});

window.addEventListener("load", () => {
    setRatingsAnimation();
    setEditorialModal();
    var articlelist = $("[data-role=article-list]");
    $(articlelist).slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        customPaging: function (slider, i) {
            return '<button type="button" role="tab"  data-webm-clickvalue="carousel-dots-articles"></button>';
        },
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"  aria-disabled="false"  data-webm-clickvalue="carousel-prev-articles">PREVIOUS</button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"  aria-disabled="false"  data-webm-clickvalue="carousel-next-articles">NEXT</button>',

        responsive: [
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 1336,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true
                }
            }
        ]
    });
});